import Alpine from "alpinejs";

Alpine.data("popup", () => ({
    init() {
        const element = this.$el;
        const href = element.getAttribute("href");
        if (!href) {
            return;
        }
        element.addEventListener("click", (event) => {
            event.preventDefault();
            const popup = window.open(
                href,
                "popup",
                "popup,noopener,location=0,menubar=0,status=0,toolbar=0,titlebar=0",
            );
            if (popup.outerWidth < screen.availWidth || popup.outerHeight < screen.availHeight) {
                popup.moveTo(0, 0);
                popup.resizeTo(screen.availWidth, screen.availHeight);
            }
        });
    },
}));
